import studentService from 'ApiService/Teacher/Student';
import { useState } from 'react';
import toast from 'react-hot-toast';

const CourseCompleteModal = ({
  isOpen,
  onClose,
  batchId,
  courses,
  completedCourses,
  setCompletedCourses,
}) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen) return null;

  const handleToggleComplete = async (courseId, isCompleted) => {
    if (!batchId) return;
    setLoading(true);
    try {
      const action = isCompleted ? 'uncomplete' : 'complete';
      const response = await studentService.markCourseComplete(
        batchId,
        courseId,
        action
      );
      if (response.data.success) {
        setCompletedCourses(response.data.completedCourses || []);
        toast.success(
          action === 'complete'
            ? 'Course marked as complete'
            : 'Course unmarked from complete'
        );
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Failed to update course');
    } finally {
      setLoading(false);
    }
  };

  const isCourseCompleted = (courseId) => {
    return completedCourses.some(
      (c) => c.course && c.course.toString() === courseId.toString()
    );
  };

  return (
    <div className="bg-black fixed inset-0 z-50 flex items-center justify-center bg-opacity-50">
      <div className="mx-4 w-full max-w-md rounded-xl bg-white p-6 shadow-xl dark:bg-navy-800">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-xl font-bold text-navy-700 dark:text-white">
            Complete Course
          </h3>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 dark:text-gray-300"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-6 w-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <p className="mb-4 text-sm text-gray-600 dark:text-gray-300">
          Mark courses as complete. Students enrolled in completed courses will
          not receive study material notifications.
        </p>

        <div className="max-h-64 space-y-3 overflow-y-auto">
          {courses.length === 0 ? (
            <p className="text-center text-gray-500">
              No courses found for this batch
            </p>
          ) : (
            courses.map((course) => {
              const isCompleted = isCourseCompleted(course._id);
              return (
                <div
                  key={course._id}
                  className="flex items-center justify-between rounded-lg border border-gray-200 p-3 dark:border-white/10"
                >
                  <span className="font-medium text-navy-700 dark:text-white">
                    {course.courseName}
                  </span>
                  <button
                    onClick={() =>
                      handleToggleComplete(course._id, isCompleted)
                    }
                    disabled={loading}
                    className={`rounded px-3 py-1 text-sm font-medium text-white transition ${
                      isCompleted
                        ? 'bg-red-500 hover:bg-red-600'
                        : 'bg-green-500 hover:bg-green-600'
                    } ${loading ? 'cursor-not-allowed opacity-50' : ''}`}
                  >
                    {isCompleted ? 'Undo Complete' : 'Mark Complete'}
                  </button>
                </div>
              );
            })
          )}
        </div>

        <div className="mt-4 flex justify-end">
          <button
            onClick={onClose}
            className="rounded-lg bg-brand-900 px-4 py-2 text-white hover:bg-brand-800 dark:bg-brand-400 dark:hover:bg-brand-300"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default CourseCompleteModal;
